export default "__VITE_ASSET__DqTOhBJQ__"